<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-row>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['number']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contract_number']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="客户" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                mode="multiple"
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                v-decorator="[
                  'client_ids',
                  {
                    rules: [
                      { required: true, message: '选择客户' },
                    ],
                  },
                ]"
                placeholder="请输入客户"
                :default-active-first-option="false"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="支付方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_payment_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="计价币种" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'pricing_currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="pricingCurrencyChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="收费标准" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['fee_standards', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="收费标准" />
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="收费标准描述" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['fee_standards_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="其他费用" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['other_fee', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="其他费用" />
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="其他费用描述" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['other_fee_desc', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="预估收费总费用" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['total_fee', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="收费总费用" />
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon && false">
            <a-form-item label="采购结算金额" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['purchase_settlement_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="增值税率（%）" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['vat', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="isCommon">
            <a-form-item label="收费期限" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-date-picker
                v-decorator="['charging_period', {rules: [{required: isCommon, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                placeholder="合同日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="担保方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                :show-arrow="false"
                show-search
                allow-clear
                v-decorator="[
                  'guarantee_method',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择"
              >
                <a-select-option v-for="(item, key) in guaranteeMethodList" :key="key" :value="key">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="存放地" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['storage_location', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="存放地"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="抵押物" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['collateral', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="抵押物"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="质押物" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['pledged_goods', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="质押物"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="抵/质押货物价值" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['collateral_pledged_goods_value', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="抵/质押货物价值"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="登记方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['registration_method', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="登记方式"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="this.type === '12'">
            <a-form-item label="担保期限" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-range-picker @change="time" format="YYYY-MM-DD" style="width: 100%" v-decorator="['guarantee_period', {rules: [{required: false, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="已存档" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch v-decorator="['is_archived', { valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea :rows="4" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col offset="8" span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { contract_update, contract_list } from '@/api/trade_contract'
import { guarantee_contract_list, guarantee_contract_update } from '@/api/trade_guarantee_contract'
import { project_client_list } from '@/api/trade_project_client'
import debounce from 'lodash/debounce'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      type: 0,
      data: {},
      clientList: [],
      guarantee_period_start_date: undefined,
      guarantee_period_end_date: undefined,
      fields: ['id', 'number', 'contract_number', 'pricing_currency', 'name', 'client_ids', 'is_archived', 'remark'],
      common_fields: ['fee_standards', 'fee_standards_desc', 'other_fee', 'other_fee_desc', 'total_fee', 'charging_period',
        'purchase_settlement_amount', 'vat', 'payment_method'],
      guarantee_fields: ['guarantee_method', 'storage_location',
        'collateral', 'pledged_goods', 'guarantee_period', 'collateral_pledged_goods_value', 'registration_method'],
      guaranteeMethodList: this.$Dictionaries.guarantee_method,
      pricingCurrency: undefined
    }
  },
  mounted () {
    this.type = this.$route.query.type
    this.loadContract()
    this.handleClientSearch(undefined)
  },
  computed: {
    isCommon () {
      return this.type < 12 && this.type !== 0
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadContract () {
      if (this.isCommon) {
        console.log('获取普通合同')
        this.fields.push(...this.common_fields)
        contract_list({ id: this.$route.params.id })
          .then(res => {
            console.log(res.data, '我是数据列表@')
            const list = res.data.entries
            if (list && list.length > 0) {
              this.data = list[0]
              this.id = this.data.id
              this.loadEditInfo(this.data)
            }
          })
      } else {
        console.log('获取担保合同')
        this.fields.push(...this.guarantee_fields)
        guarantee_contract_list({ id: this.$route.params.id }).then(res => {
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.id = this.data.id
            this.loadEditInfo(this.data)
          }
        })
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.$route.query.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          if (this.isCommon) {
            contract_update(values, this.id)
              .then((res) => {
                if (res.code === 1000) {
                  this.handleGoBack()
                  console.log(res, '修改成功')
                }
              })
          } else {
            values['sell_contract_id'] = this.sell_contract_id
            if (this.guarantee_period_start_date !== undefined && this.guarantee_period_end_date !== undefined) {
              values['guarantee_period_start_date'] = this.guarantee_period_start_date
              values['guarantee_period_end_date'] = this.guarantee_period_end_date
            }
            guarantee_contract_update(values, this.id).then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            })
          }
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, this.fields)
        if (this.isCommon) {
          formData.pricing_currency = '' + formData.pricing_currency
          formData.payment_method = '' + formData.payment_method
          this.pricingCurrency = data.pricing_currency
        } else {
          formData.guarantee_method = '' + formData.guarantee_method
          if (data.guarantee_period_start_date !== undefined && data.guarantee_period_start_date !== '1970-01-01' && data.guarantee_period_end_date !== undefined && data.guarantee_period_end_date !== '1970-01-01') {
            formData.guarantee_period = [moment(data.guarantee_period_start_date),
              moment(data.guarantee_period_end_date) ]
            this.guarantee_period_start_date = data.guarantee_period_start_date
            this.guarantee_period_end_date = data.guarantee_period_end_date
          } else {
            formData.guarantee_period = undefined
          }
        }
        console.log('formData', formData)
        this.id = formData.id
        this.sell_contract_id = data.sell_contract_id
        form.setFieldsValue(formData)
      })
    },
    time (dates, dateStrings) {
      this.guarantee_period_start_date = dateStrings[0]
      this.guarantee_period_end_date = dateStrings[1]
      console.log(this.otherData, '时间')
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    }
  }
}
</script>
